// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38WJ7","question":"styles_question__1CWpV","description":"styles_description__lxU3t"};